import { render, staticRenderFns } from "./FileEditor.vue?vue&type=template&id=02c40e8e&scoped=true&"
import script from "./FileEditor.vue?vue&type=script&lang=js&"
export * from "./FileEditor.vue?vue&type=script&lang=js&"
import style0 from "./FileEditor.vue?vue&type=style&index=0&id=02c40e8e&prod&lang=scss&"
import style1 from "./FileEditor.vue?vue&type=style&index=1&id=02c40e8e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c40e8e",
  null
  
)

export default component.exports